import produce from 'immer';

import { DataLoadedAction, TemplateLoadedAction, TypeKeys } from '../../state-management/widgetblock/actions/types';
import reduceDatasetsByViewblockState from '../../utils/reduceDatasetsByViewblockState';
import { Dataset, ImageFeedConfigBlockState, ImageFeedState } from './types';

type Actions = TemplateLoadedAction<ImageFeedConfigBlockState> | DataLoadedAction<Dataset[]>;

const INITIAL_STATE: ImageFeedState = {
    datasets: null,
    viewblockState: null,
};

const reducer = produce((draft, action: Actions) => {
    switch (action.type) {
        case TypeKeys.TEMPLATE_LOADED:
            draft.viewblockState = action.payload.data;

            break;

        case TypeKeys.DATA_LOADED:
            draft.datasets = action.payload.data;

            break;
    }

    const { datasets, viewblockState } = draft;

    if (datasets && viewblockState) {
        draft.model = { datasets: reduceDatasetsByViewblockState({ datasets, viewblockState }) };
    }
}, INITIAL_STATE);

export default reducer;
